export enum EstimatorType {
  PROBABILITY_ESTIMATOR = 'PE',
  APPROVED_LOAN = 'AL',
}
